module.exports = __webpack_public_path__ + "img/logo.7926c7d4.png";